import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, AfterViewInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MetaDefinition } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { slideInDown } from 'ng-animate';
import { Subscription } from 'rxjs';
import { ICurrency, ISystemEvent } from '../../../shared/models';
import {
  ApiService,
  AuthService,
  EventsService, FbService, FundraiserService, HomepageService, ScriptLoaderService, SeoService, UtilService, VariablesService, VwoService
} from '../../../shared/services';
import { IBasicInfo, IFundraiser, IStoryDescription } from '../../models/fundraiser.model';
import { FrTabsComponent } from '../../../common/common-fundraiser/components/fr-tabs/fr-tabs.component';
import { DonateNowComponent } from '../../../common/donate-now/components/donate-now/donate-now.component';
import { environment } from '../../../../environments/environment';
import { PaymentUtilService } from '../../../common/payment/services';
import { PrivateFundraiserComponent } from '../private-fundraiser/private-fundraiser.component';

interface SupportersObject {
  topDonors: any;
  mostRaisedSocial: any;
  supporters: any;
}

@Component({
  selector: 'app-fundraiser',
  templateUrl: './fundraiser.component.html',
  styleUrls: ['./fundraiser.component.scss'],
  animations: [
    trigger('slideUp', [transition('* => *', useAnimation(slideInDown, {
      params: { timing: 0.5 }
    }))])
  ],
})
export class FundraiserComponent implements OnInit, AfterViewInit, OnDestroy {
  isMobile: any;
  param;
  fundraiser: IFundraiser;
  basicInfo = {} as IBasicInfo;
  openSimilarFundraiserDialog = true;
  isLoggedIn;
  isFundraiserEnded;
  isSuccessfullyFunded;
  userData;
  donationCard = {
    donor: [],
    shary: []
  };

  comments;
  updates;
  tipModelEntities = [1399904, 1494328, 1427863];
  campaigner;
  beneficiary: any = {};
  activeTab = 'About';
  similarFundraisers;
  supportersObject: SupportersObject = {
    topDonors: '',
    mostRaisedSocial: '',
    supporters: '',
  };
  inViewPort = {
    tabs: false,
    similar: false
  };
  currencyIcon;
  currency;
  kCartCurrency;
  campaignUrl;
  sharedCounts = {
    fb: 0,
    whatsapp: 0
  };
  tags: MetaDefinition[];
  metaData;
  shareMessages = {
    whatsapp: ''
  };
  isLoading = false;
  isDonated = false;
  donateBtnLabel;
  isMicroSite;
  currencySubs: Subscription;
  isHeaderSticky: boolean;
  tickrIsShown: boolean;
  isSimilarPopupShowed = false;
  showEditFrBtn = false;
  donateOpened = false;
  isPrivateFundraiser;
  socialImpactCurrencyList = {
    INR: 5000,
    USD: 200,
    GBP: 50,
    EUR: 50,
    AED: 250,
    SAR: 250,
    SGD: 100,
    CAD: 250,
    HKD: 1500,
    QAR: 700
  };
  isFos = false;
  isSipCause = false;
  causeId = [4, 7, 59, 103, 150, 156, 159];

  isDonationDetailsCalled = false;

  loadDonationData = false;
  hide_el = true;
  qParams;
  currencyInfo: ICurrency;
  paymentDialogType = 'onpage';
  donationTitle;
  endedFundraiserTitle: string;
  endedFundraiserSubtitle: string | null;
  trendingFundraiserData;
  endedCampaignPageData = [];
  endedCampaignPageDataType;

  subs: Subscription[] = [];

  showEndCampaignPage: boolean = false;

  @ViewChild('similarFundraiser', { static: true }) public similarFundraiser: ElementRef<HTMLElement>;
  @ViewChild('tabs') public tabs: FrTabsComponent;
  @ViewChild('donateNowBtn') public donateNowBtn: DonateNowComponent;

  constructor(
    private api: ApiService,
    private homepageService: HomepageService,
    public actRoute: ActivatedRoute,
    public fundraiserService: FundraiserService,
    public util: UtilService,
    public scriptLoader: ScriptLoaderService,
    public vars: VariablesService,
    public seoService: SeoService,
    public fbService: FbService,
    public dialog: MatDialog,
    private events: EventsService,
    private paymentUtilService: PaymentUtilService,
    public vwo: VwoService,
    private router: Router,
    @Inject(DOCUMENT) public document: Document,
    private auth: AuthService,
    private cdr: ChangeDetectorRef
  ) {
    this.vars.campaignType = 'campaign';
    this.vars.pageName = 'campaign';
    this.getParam();

  }

  ngOnInit() {
    this.vars.selected_insurance = null;
    this.isMobile = this.util.isMobile();
    if (this.actRoute.snapshot.queryParams['st'] === 'f') {
      this.paymentUtilService.isSubmitted.next(true);
    }
    if(this.actRoute.snapshot.queryParams['randomcampaign'] === "1"){
      this.vars.showRandomBanner = true;
    } else {
      this.vars.showRandomBanner = false;
    }
    if (typeof document !== 'undefined') {
      document.body.classList.add('fundraiserPage');
    }
    if (this.util?.isBrowser && this.util.getUserData()) {
      this.auth.getUserProfile().subscribe((res: any) => {
        if (res?.data) {
          this.userData = res?.data;
          this.vars.userData.next(this.userData);
          this.util.setUserData(this.userData);
        }
      });
    }
    // this.util.loadVWO();
    this.vars.userData.subscribe(res => {
      this.userData = res;
      this.checkForMedDoc();
    });
    this.checkUserLogin();
    this.campaignUrl = this.util.domain_details.domain_url + '/fundraiser/' + this.param;
    this.isMicroSite = this.util.isMicroSite();
    this.vars.mainLayoutConfig.next({
      showHeader: true,
      showFooter: true,
      logoNavigate: true,
      showMenus: false,
      showProfile: true,
      showSearch: false,
      trustedLine: true,
      animateHeader: false,
      showCurrency: true,
      headerClass: '',
      zendesk: false,
      hideAbandonedCart: true,
      headerTopSticky: false,
      showDownloadApp: true
    });
    this.dialog.closeAll();
    // this.vars.paymentDialogType.next('full');
    if (this.util.storage?.getFromSession('india') && this.param.op !== 'st') {
      this.util.storage.addSessionData('india', false);
    }

    this.actRoute.queryParams.subscribe((qParams) => {
      if (qParams.hasOwnProperty('show') && qParams.show === "endedPage") {
        this.showEndCampaignPage = true;
      } else {
        this.showEndCampaignPage = false;
      }
    });
  }

  goBackToBrowse(){
    this.vars.showRandomBanner = false;
    this.router.navigate(['/crowdfunding/fundraisers']);
    this.events.sendSystemEvent(
      {
        eventName: 'campaign-page-random-picker-back-card-clicked',
        page_name: this.vars.pageName,
        info_1: this.fundraiser?.id || ''
      }
    ).subscribe(_ => _);
  }

  closeRandomBanner(){
    this.vars.showRandomBanner = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.util.scrollToTop();
    }, 1000);
  }
  /**Get the params from URL */
  getParam() {
    this.actRoute.params.subscribe((params) => {
      this.param = params['tag'];
      const qParams = this.actRoute.snapshot.queryParams;
      this.qParams = qParams;
      if (qParams.hasOwnProperty('hide_el')) {
        this.hide_el = !qParams.hide_el;
      }
      if (qParams['type'] === 'lead') {
        this.paymentDialogType = 'lead';
        this.donationTitle = 'Stories.donations.provideWithDetails';
        this.vars.paymentDialogType.next('lead');
      }
      this.seoService.createAmpHtml('fundraiser', this.param);
      if (this.util.isBrowser) {
        this.getSocialShares();
        !this.currency ? this.getCurrency() : this.getFundraiser(this.param, this.currency);
      } else {
        this.getFundraiser(this.param, 'INR');
      }
    });
  }

  /**check user logged in status */
  checkUserLogin() {
    this.util.isLoggedIn.subscribe({
      next: (res) => {
        this.isLoggedIn = res;
        this.getDonorsDetails();
        if (this.isLoggedIn) {
          this.vars.userData.subscribe({
            next: userData => {
              try {
                if (userData && this.vars.fundraiser) {
                  // tslint:disable-next-line:max-line-length
                  if (userData.id === this.vars.fundraiser.creator_entity_details_id || userData.id === this.vars.fundraiser.entity_details_id) {
                    this.showEditFrBtn = true;
                  }
                  if (!this.isDonationDetailsCalled) {
                    this.getDonorCardDetails(this.vars.fundraiser.id, userData.id);
                  }
                } else {
                  this.showEditFrBtn = false;
                }
              } catch (error) {
                console.log(error);
              }
            }
          });
        }
      }
    });
  }
  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.currencySubs = this.util.currency.subscribe((res) => {
      if (res) {
        this.currency = res;
        this.currencyInfo = this.util.getCurrencyIcon(res);
        this.getFundraiser(this.param, res);
      }
    });
  }
  /**Check if fundraiser in urgent state */
  checkIfUrgentFundraiser() {
    if (this.fundraiser) {
      if (this.fundraiser.display_type_self === 'urgent' || (this.fundraiser.cause && this.fundraiser.cause.info_1 === 'Medical')) {
        return true;
      }
    }
  }
  /**Set Basic Info */
  setBasicInfo(data: any[]) {
    if (data && data.length) {
      for (const item of data) {
        this.basicInfo[item.info_type] = item.info_1 || '';
      }
      this.vars.basicInfo = this.basicInfo;
      this.setCampaigner();
    }
  }
  /**Set the logic of the
   * Campaigner(Owner) and Beneficiary card
   */
  setCampaigner() {
    this.campaigner = this.fundraiser.campaigner;
    if (this.campaigner) {
      this.campaigner['city'] = this.fundraiser.address_1;
    }
    if (this.fundraiser?.beneficiary?.full_name) {
      this.beneficiary = this.fundraiser.beneficiary;
    } else if (this.basicInfo.beneficiary_name) {
      this.beneficiary['full_name'] = this.basicInfo.beneficiary_name;
      this.beneficiary['relation'] = this.basicInfo.beneficiary_relation;
      this.beneficiary['avtar'] = this.fundraiser.media_beneficiary;
    } else {
      this.beneficiary = {};
    }
  }
  /**Open payment form from buttons */
  openPaymentForm(option) {
    this.donateNowBtn.donateNow(this.donateNowBtn.paymentModule);
    if (option === 'c') {
      this.vars.setPaymentOption.next({ card: true });
    } else if (option === 'nb') {
      this.vars.setPaymentOption.next({ netbanking: true });
    }
  }
  /**Scroll into view of the element */
  scrollIntoView(name) {
    this.tabs.setTab('About');
    setTimeout(() => {
      this.vars.scrollIntoView.next({
        name: name,
        scroll: true
      });
    }, 500);
  }
  /**Get the Active tab */
  getAciveTab(event) {
    this.activeTab = event;
  }
  /**is header of the tabs is sticky */
  headerSticky(event) {
    this.isHeaderSticky = event;
  }
  /**Tabs in viewport */
  tabsInView(event) {
    if (this.fundraiser && event.visible === true && !this.inViewPort.tabs && this.param) {
      this.loadDonationData = true;
      this.getDonorsDetails();
      this.getFundraiserCommnets(this.param);
      this.getFundraiserUpdates(this.param, 2);
      this.inViewPort.tabs = true;
    }
  }

  getDonorsDetails() {
    if (!this.fundraiser?.settings?.nodonorlist && (this.isLoggedIn || !this.vars.mandateLoginCheck) && this.loadDonationData) {
      this.loadDonationData = false;
      this.getDonorListObject();
      this.getTopDonors(this.param);
      this.getMostRaisedSocialSharing(this.fundraiser.id);
      const payload = {
        orderby: 'donated_amount',
        sortby: 'desc',
        limit: 5,
        page: 1
      };
      this.getSupporters(this.param, payload);
    }
  }

  similarFundsInView(event) {
    if (this.fundraiser && event.visible === true && !this.inViewPort.similar) {
      if (!this.isFundraiserEnded) {
        this.getSimilarFundraisers(this.fundraiser.id);
        this.inViewPort.similar = true;
      }
    }
  }
  /**fixed postion */
  fixedPostion(event) {
    if (event.visible === true) {
      event.target.children[0].classList.remove('fixed-position');
      // this.document.body.style.marginBottom = 'auto';
    } else if (event.visible === false) {
      event.target.children[0].classList.add('fixed-position');
      // this.document.body.style.marginBottom = '70px';
    }
  }
  /**Load the JS Library */
  loadLibrary() {
    this.scriptLoader.load('facebooksdk').then((data) => {
    }).catch(error => { });
  }
  /**Set title of the page */
  setTitle() {
    this.util.setPageTitle(this.fundraiser.title);
  }
  /**Share events of the share buttons */
  // shareButtonsEvents(button) {
  //   this.shareMessagesService.shareEvents(button + ' share', button === 'facebook' ? 'PosOS' : '');
  // }
  /**Add meta tags */
  addMetaTags() {
    this.metaData = this.seoService.fundraiserMetaTags(this.fundraiser, this.campaignUrl);
    this.vars.metaDataOfPage = this.metaData;
    this.tags = this.seoService.createTagObject(this.metaData);
    if (this.fundraiser.stop_google_index) {
      this.tags.push({ name: 'robots', content: 'noindex' });
      this.tags.push({ name: 'googlebot', content: 'noindex' });
    }
    this.seoService.addMetaTags(this.tags);
    const schemaObj = {
      '@context': 'http://schema.org',
      '@type': 'Article',
      'mainEntityOfPage': `${this.metaData.url}`,
      'description': `Support ${this.metaData.campaigner}'s fundraiser: on Ketto, India's largest crowdfunding site`,
      'publisher': {
        '@type': 'Organization',
        'name': 'Ketto - Crowdfunding India',
        'logo': {
          '@type': 'ImageObject',
          'url': `/assets/images/logo.svg`,
          'width': 165, 'height': 60
        }
      },
      'headline': `${this.metaData.title}`,
      'datePublished': `${this.fundraiser.creation_date.split(' ')[0]}`,
      'dateModified': `${new Date().toISOString().split('T')[0]}`,
      'author': {
        '@type': 'Person',
        'name': `${this.fundraiser.campaigner ? this.fundraiser.campaigner.full_name : ''}`
      },
      'articleBody': `${this.metaData.description}`,
      'image': {
        '@type': 'ImageObject',
        'url': `${this.metaData.image}`,
        'width': null,
        'height': null
      }
    };
    this.seoService.schemaOrgObject(schemaObj);
    this.seoService.schemaOrgObject(this.seoService.schema.home_org);
    this.seoService.schemaOrgObject(this.seoService.schema.home_webpage);
    this.seoService.updateCanonicalURL(`/fundraiser/` + this.fundraiser.custom_tag);
  }
  /**Get the user id of the user */
  getUserId(campaignId) {
    const qParams = this.actRoute.snapshot.queryParams;
    if (qParams['shby'] && qParams['utm_content']) {
      this.getSharyCardDetails(campaignId, qParams['utm_content']);
    }
    this.qParams = qParams;
    if (this.isLoggedIn) {
      this.getDonorsDetails();
      this.vars.userData.subscribe({
        next: res => {
          if (res && !(this.donationCard.donor && this.donationCard.donor.length)) {
            this.getDonorCardDetails(campaignId, res.id);
          }
        }
      });
    } else {
      if (!this.util.actRoute.snapshot.queryParams?.user_id) {
        this.getThisUserDonations();
      }
      this.actRoute.queryParams.subscribe((params) => {
        if (params.user_id) {
          this.getDonorCardDetails(campaignId, params.user_id);
        }
        if (!this.tickrIsShown) {
          this.tickrIsShown = true;
        }
      });
    }
  }
  /**Open modal */
  openModal(template) {
    this.dialog.open(template, {
      width: '100vw',
      maxWidth: this.isMobile ? '100%' : '955px',
      height: '100vh',
      maxHeight: this.isMobile ? '100%' : '564px',
      closeOnNavigation: true,
      panelClass: ['round-dialog', 'similar-fr-modal']
    });
    this.events.sendSystemEvent(
      {
        eventName: 'similar_fundraiser_popup',
        page_name: this.vars.pageName
      }
    ).subscribe(_ => _);
  }
  /**Set the Donate Button Label */
  setDonateBtnLabel(fundraiser) {
    let btnText = '';
    fundraiser.basicinfo.forEach(element => {
      if (element.info_type === 'contribute') {
        btnText = element.info_1;
      }
    });
    if (btnText && btnText.trim() !== '') {
      this.donateBtnLabel = btnText;
    } else {
      this.donateBtnLabel = 'Contribute Now';
    }
  }
  /**Get The active status of the fundraiser */
  getFundriserStatus() {
    this.isFundraiserEnded = this.util.checkFundraiserEnded(this.fundraiser.status_flag, this.fundraiser.end_date);
    this.vars.isFundraiserEnded = this.isFundraiserEnded;
    if (this.isFundraiserEnded) {
      if (this.fundraiser.raised) {
        this.isSuccessfullyFunded = this.util.checkIfSuccessfullyFunded(
          this.fundraiser.amount_requested, this.fundraiser.raised.raised
        );
      }
      // Set verbiage for ended fundraiser
    if (this.isLoggedIn && this.isDonated) {
      this.endedFundraiserTitle = `Hello ${this.userData?.full_name?.toLowerCase() || ''}, Thanks for your contribution.`;
      this.endedFundraiserSubtitle = 'This fundraiser is not accepting funds anymore';
    } else {
      this.endedFundraiserTitle = 'This fundraiser is not accepting funds anymore';
      this.endedFundraiserSubtitle = null;
    }

     if(this.actRoute.snapshot.queryParams?.show !== 'default'){
      this.util.router.navigate([], {
        queryParams: { show: 'endedPage' },
        queryParamsHandling: 'merge',
      });
     } 
    }
  }

  getSimilarFundraisersData(customTag) {
    this.endedCampaignPageData = [];
    const qParam = `?with=leaderboard&currency=${this.currency ? this.currency : 'inr'}`;
    this.fundraiserService.getSimilarFundraisers(customTag, qParam).subscribe((res: any) => {
      this.similarFundraisers = (res.data || []).map(item => {
        if (item?.parent_cause_id === 149 && item?.amount_requested ) {
          const percent = ((item.raised.raised ?? 0) / item.amount_requested) * 100;
          if (percent > 80) {
            return {
              ...item,
              raised: {
                ...item.raised,
                raised: Math.floor(item.amount_requested * 0.8)
              }
            };
          }
        }
        return item;
      });
      if (res?.data?.length < 1) {
        this.getTrendingFundraisersData()
      } else {
        this.endedCampaignPageData = this.similarFundraisers;
        this.endedCampaignPageDataType = "SIMILAR_FUNDRAISER"
      }
    });
  }

  getTrendingFundraisersData(){
    const qparams = '&with=basicInfo';
    this.homepageService.getTrendingFR(this.currency, qparams).subscribe((res: any) => {
      this.trendingFundraiserData = res.data.data;
      this.endedCampaignPageData = this.trendingFundraiserData;
      this.endedCampaignPageDataType = "TRENDING_FUNDRAISER"
    });
  }
  /**Start the similar fundraiser */
  startSimilar() {
    const campaignType = this.util.getCampaignTypeFromId(this.fundraiser.parent_cause_id);
    const url = this.util.domain_details.domain_url + '/campaign/start_new_campaign.php?type=' + campaignType;
    this.util.nativeNavigation(url);
  }
  /**
   * ALL API CALLS
   * +=====+=====+=====+=====+=====+====+
   */
  /**Get the details of the fundraiser */
  getFundraiser(customTag, currency) {

    this.isDonated = false;
    this.vars.showKCart = false;
    this.vars.selectedKCart = null;
    this.isHeaderSticky = false;
    this.fundraiser = undefined;
    let qParam = `?with=viewmedicalbill;gallery;basicinfo;validCoupon.redeemTransferApply;foscampaign;verifiedCampaign;sipcause;`
      .concat(`beneficiary.avtar;campaigner.avtar;activeteam.member.avtar;activeteam.member.sociallinks;organiser;tipModel;isStory;`)
      .concat(`rewards;banktransfer;cause;campaigner.social;campaigner.aggFundraiser;campaigner.aggdonation;mediaBeneficiary;multiCampaigns;beneficiaryname;userFollowed;fbShareCount`)
      .concat(`;matchingDonor;googleIndex&currency=${currency}&page_type=${this.vars.pageName}`);
    const utms = this.util.getUTMonly('url_string');
    if (utms) {
      qParam = qParam + `&device=${this.vars.deviceType}&${utms}`;
    }
    if (this.vwo.blur_image_AB()) {
      qParam = qParam + `&blur_image_AB=${this.vwo.blur_image_AB()}`;
    }
    this.fundraiserService.getCampaign(customTag, qParam).subscribe((res: any) =>
      this.handleFundraiserData(res, customTag, currency),
      (errorRes) => {
        this.util.router.navigate(['/new/404'], { queryParams: { redirectURL: this.util.domain_details.full_url } });
      });
  }

  handleFundraiserData(res, customTag, currency): void {
    this.vars.fundraiser = res?.data;
    if (res?.data?.login_required) {
      this.vars.mandateLoginCheck = true;
    } else {
      this.vars.mandateLoginCheck = false;
    }
    if (res?.data?.show_product) {
      this.vars.showKCart = true;
      this.vars.kCartCurrencyChange.next({ currency: currency, preSelect: true });
    } else {
      this.vars.showKCart = false;
    }
    this.util.setFrequentVisitCampaign(res?.data?.campaign_id);
    if ((res.data && res.data.foscampaign && res.data.foscampaign.info_1 === '1' &&
      res.data.verified_campaign && res.data.verified_campaign.info_1 === '1') || res.data.parent_cause_id === 149) {
      this.isFos = true;
    }
    if (res.data && res.data.fb_share_count) {
      this.sharedCounts.fb = (+res.data.fb_share_count.info_1) !== 0 ? res.data.fb_share_count.info_1 : '';
    }
    this.isPrivateFundraiser = res.data.basicinfo.some(item => item.info_type === 'is_private' && item.info_1 === '1');
    const privateFundPinAllowed = this.util.cookie.getCookie(`privateFundPinAllowed-${customTag}`);
    if (this.isPrivateFundraiser && privateFundPinAllowed !== customTag) {
      this.askForPin(res.data.id, res, customTag, currency);
    } else {
      this.nonPrivateFlow(res, customTag, currency);
    }

    if (res.data && res.data.is_story) {
      this.vars.campaignType = 'stories';
    }

    this.getSimilarFundraisersData(this.fundraiser?.id);
    if(this.userData?.id){
      this.getDonorCardDetails(this.fundraiser?.id, this.userData?.id);
    }
  }

  nonPrivateFlow(res, customTag, currency) {
    res.data.currency = currency;
    this.fundraiser = res.data;
    this.isSipCause = this.fundraiser.sipcause ? true : false;
    this.vars.sip_cause.next(this.fundraiser.sipcause || null);

    this.vars.showStoryOnFundraiser = false;
    // this.util.doc?.body?.classList?.add('fundraiserPage');
    if (this.fundraiser?.parent_cause_id === 20 && this.vars.validCausePM.includes(this.fundraiser.cause_id) && this.vwo.fundraiser_on_story_AB()) {
      this.vars.showStoryOnFundraiser = true;
      // this.util.doc?.body?.classList?.remove('fundraiserPage');
    }

    if (res.data.theme && res.data.logo) {
      this.vars.theme.next({
        'primary_color': res.data.theme.info_1,
        'text_color': res.data.theme.info_2,
        'logo': res.data.logo.cdn_path,
        'access_url': res.data.access_url,
        'website_url': res.data?.beneficary?.website_1
      });
    }
    this.fundraiserService.getCampaign(`${customTag}/raised`, `?currency=${currency}&page_type=${this.vars.pageName}`)
      .subscribe((res2: any) => {
        this.fundraiser.raised = res2?.data?.raised;
        this.fundraiser.raised.beforeTickrBackers = this.fundraiser.raised ? this.fundraiser.raised.backers : 0;
      });
    this.campaignUrl = this.util.domain_details.full_url;
    this.isMicroSite = this.util.isMicroSite();
    this.addMetaTags();
    this.getFundriserStatus();
    this.setBasicInfo(res.data.basicinfo);
    this.setTitle();
    this.getUserId(this.fundraiser.id);
    this.inViewPort.similar = undefined;
    this.inViewPort.tabs = undefined;
    this.setDonateBtnLabel(this.fundraiser);
    this.campaignVisitTrack();
    if (this.util.isBrowser && typeof window !== 'undefined') {
      if (this.tipModelEntities.includes(this.fundraiser.event_entity_details_id)) {
        (<any>window).covidCampaign = true;
      } else {
        (<any>window).covidCampaign = false;
      }
      this.pageViewEvents();
      // setTimeout(() => {
      //   if (this.isFundraiserEnded && this.fundraiser?.parent_cause_id === 48) {
      //     this.getSimilarFundraisers(this.fundraiser.id);
      //   }
      // }, 3000);
    }
  }

  askForPin(campaignId, res, customTag, currency) {
    const dialogRef = this.dialog.open(PrivateFundraiserComponent, {
      width: '540px',
      height: 'auto',
      panelClass: 'pin-modal',
      backdropClass: 'private-fund-bg',
      data: {
        campaignId,
        customTag
      }
    });
    dialogRef.backdropClick().subscribe(value => {
      dialogRef.close();
      this.router.navigate(['/']);
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value && value.data) {
        // call non private flow
        this.nonPrivateFlow(res, customTag, currency);
      }
    });
  }
  /**Get top donors */
  getTopDonors(customTag) {
    const qParam = `?search=is_anonymous:0&limit=5&orderBy=donated_amount&sortedBy=desc&page_type=${this.vars.pageName}`;
    this.fundraiserService.getDonors(customTag, qParam).subscribe((res: any) => {
      res.data.data = this.util.handleSupporters(res?.data?.data||[]);
      this.supportersObject.topDonors = res.data;
    });
  }
  /**Most Raised from Social Sharing */
  getMostRaisedSocialSharing(campaignId) {
    const qParam = `?limit=5&page_type=${this.vars.pageName}`;
    this.fundraiserService.getSocailDonors(campaignId, qParam).subscribe((res: any) => {
      this.supportersObject.mostRaisedSocial = res.data.conversion;
    });
  }
  /**Supporters */
  getSupporters(customTag, page) {
    this.isLoading = true;
    // tslint:disable-next-line: max-line-length
    const qParam = `?with=activation;comments;matchingDonation&limit=${page.limit}&page=${page.page}&orderBy=${page.orderby}&sortedBy=${page.sortby}&page_type=${this.vars.pageName}`;
    this.fundraiserService.getDonors(customTag, qParam).subscribe(
      (res: any) => {
        res.data.data = this.util.handleSupporters(res?.data?.data||[]);
        this.supportersObject.supporters = res?.data;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.supportersObject.supporters = {
          ...(this.supportersObject.supporters || {}),
          error: { status: error.status }
        };
      }
    );
  }
  /**Get donor list variable from donor component */
  getDonorListObject() {
    this.util.donorList$.subscribe((res: any) => {
      if (res) {
        this.getSupporters(this.param, res);
      }
    });
  }
  /**Get the fundraiser comments */
  getFundraiserCommnets(customTag) {
    const qParam = '?limit=10';
    this.fundraiserService.getFundraiserComments(customTag, qParam).subscribe((res: any) => {
      this.comments = res.data;
    });
  }
  /**Get the similar fundraiser */
  getSimilarFundraisers(customTag) {
    const qParam = `?with=leaderboard&currency=${this.currency ? this.currency : 'inr'}`;
    this.fundraiserService.getSimilarFundraisers(customTag, qParam).subscribe((res: any) => {
      this.similarFundraisers = res.data;
      if (!this.isSimilarPopupShowed) {
        if (this.isFundraiserEnded && this.openSimilarFundraiserDialog && res.data && res.data.length && Array.isArray(res.data)) {
          // added check if page is on same page
          if (this.vars.pageName === 'campaign' && !this.vars.showStoryOnFundraiser) { 
            this.openModal(this.similarFundraiser);
            this.isSimilarPopupShowed = true;
          }
        }
      }
    });
  }
  /**Get fundraiser updates */
  getFundraiserUpdates(customTag, limit) {
    const qParam = `?with=owner.avtar;comments&limit=${limit}&orderBy=creation_time&sortedBy=desc`;
    this.fundraiserService.getFundraiserUpdates(customTag, qParam).subscribe((res: any) => {
      this.updates = res.data;
      this.updates.data['facebook'] = {
        label: 'Spread the word',
        count: this.sharedCounts.fb,
        campaign_url: this.campaignUrl
      };
      for (let i = 0; i < this.updates.data.length; i++) {
        res.data.data[i].owner['creation_time'] = res.data.data[i].creation_time;
        if (!this.updates.data[i].user_liked) {
          this.updates.data[i].user_liked = { 'status': 0 };
        }
        const qParam1 = `/${this.updates.data[i].id}/comments?limit=5`;
        this.fundraiserService.getFundraiserUpdates(customTag, qParam1).subscribe((res1: any) => {
          this.updates.data[i]['comments'] = res1.data;
          this.updates.data[i]['comments'].placeholder = 'Write something to cheer ' + (this.fundraiser?.campaigner?.fname || '');
        });
        this.updates.data[i]['comments'].placeholder = 'Write something to cheer ' + (this.fundraiser?.campaigner?.fname || '');
      }
    });
  }
  /**Get donor card details */
  getDonorCardDetails(campaignId, userId) {
    this.isDonationDetailsCalled = true;
    const qParam = `?with=donoravtar;comments;activation&donor_entity_details_id=${userId}&sortedBy=desc&orderBy=id`;
    this.fundraiserService.getDonorCardDetails(campaignId, qParam).subscribe((res: any) => {
      this.donationCard.donor = res.data;
      if (this.donationCard.donor.length === 0) {
        // This is to maintain tickr does not start again upon currency change
        if (!this.tickrIsShown) {
          this.tickrIsShown = true;
        }
      }
      if (res.data && res.data.length) {
        this.isDonated = true;
        if (this.isLoggedIn && this.isDonated) {
          if(this.util.isMobile()){
            this.endedFundraiserTitle = `Hello ${this.userData?.full_name?.toLowerCase() || ''},<br/> Thanks for your contribution.`;
          }else{
            this.endedFundraiserTitle = `Hello ${this.userData?.full_name?.toLowerCase() || ''}, Thanks for your contribution.`;
          }
          this.endedFundraiserSubtitle = 'This fundraiser is not accepting funds anymore';
        } else {
          this.endedFundraiserTitle = 'This fundraiser is not accepting funds anymore';
          this.endedFundraiserSubtitle = null;
        }
        this.vars.fundraiser.isDonated = true;
      }
    });
  }/**Get Shary card details */
  getSharyCardDetails(campaignId, userId) {
    const qParam = `?with=donoravtar;comments;activation;donor&donor_entity_details_id=${userId}&sortedBy=desc&orderBy=creation_date`;
    this.fundraiserService.getSharyCardDetails(campaignId, qParam).subscribe((res: any) => {
      this.donationCard.shary = res.data.orders;
    });
  }
  /**Get social shared os the campaign */
  getSocialShares() {
    // removed as now fb share count will come in fundraiser api
    // this.getFacebookShares();
    this.getWatsappShare();
  }
  /**Get the fb shared */
  getFacebookShares() {
    const selectedId = this.fbService.getFacebookID();
    const url = `/fundraiser/${this.param}&fields=engagement&access_token=${encodeURI(selectedId)}`;
    this.fundraiserService.getFacebookShares(url).subscribe((res: any) => {
      this.sharedCounts.fb = res.engagement.share_count;
    });
  }
  /**Get Whats app share */
  getWatsappShare() {
    this.sharedCounts.whatsapp = this.fundraiserService.getWhatsappShares();
  }
  /**Report this project */
  reportProject() {
    // tslint:disable-next-line:max-line-length
    const url = this.util.domain_details.domain_url + `/support/contact-us.php?contact_ref=abuse&campaign_id=${this.fundraiser.id}&campaign=${this.fundraiser.custom_tag}`;
    this.util.nativeNavigation(url);
  }
  /**All events */
  pageViewEvents() {
    // Measure a view of Product details
    const campaignType = `${this.util.getCampaignTypeFromId(this.fundraiser.parent_cause_id)}`;
    const gtmData = {
      'event': 'productDetail',
      'currency': this.currency,
      'ecommerce': {
        'detail': {
          'actionField': { 'list': `${this.vars.pageName}` }, // actions have an optional list property.
          'products': [{
            'name': `${this.fundraiser.custom_tag}`, // Campaign Name
            'id': `${this.fundraiser.id}`, // Campaign ID.
            'category': campaignType,  // Campaign Type
            'variant': `${this.fundraiser.cause_id}`,
            'dimension5': '', // cd_Fundraiser Attributes
            'dimension7': `${this.fundraiser.cause_id}`, // cd_Campaign Cause ID
            'dimension8': `${this.fundraiser.custom_tag}`, // cd_Campaign Custom Tag
            'dimension9': `${this.fundraiser.id}`, // cd_Campaign ID
            'dimension10': campaignType // cd_Campaign Type
          }]
        }
      }
    };
    this.events.gtmPush(gtmData);
    this.events.fbPixelPush('ViewContent', {});
    const systemData: ISystemEvent = {
      eventName: 'campaign_viewed',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'campaign',
      info_2: this.fundraiser?.parent_cause_id?.toString() || ''
    };
    this.events.onLoadSystemEvent(systemData);
    const pageViewSysEvent: ISystemEvent = {
      eventName: 'pageView',
      event_type: 'campaign',
      event_type_id: this.fundraiser.id,
      page_name: 'campaign',
      info_1: this.currency,
      info_3: 'campaign'
    };
    this.events.onLoadSystemEvent(pageViewSysEvent);
    const claverTap = {
      'Campaign Id': this.fundraiser.id,
      'Page URL': this.util.domain_details.full_url,
      'Campaign Title': this.fundraiser.title,
      'Browser': this.util.detectBrowser(),
      'Campaign Type': this.util.getCampaignTypeFromId(this.fundraiser.id),
      'Cause ID': this.fundraiser.cause_id,
      'Device Type': this.util.isMobile() ? 'Mobile' : 'Desktop',
      'Campaign image URL' : this.fundraiser?.gallery[0]?.cdn_path || '',
      'Custom Tag' : this.fundraiser?.custom_tag || '',
      'campaign expiry date': this.fundraiser.end_date,
      'info_2': this.fundraiser?.parent_cause_id?.toString() || ''
    };
    this.events.claverTapPush('Campaign Viewed', claverTap);
    // this.events.vwoPush(vwoDataPush);
  }
  /**Go to the manage fundraiser */
  goToManageFund() {
    const url = environment.manage_domain + '/manage/' + this.fundraiser.id + '/edit';
    this.util.nativeNavigation(url);
  }

  /** Track user on load  */
  campaignVisitTrack() {
    const user = this.util.getUserData();
    const payload = {
      source: this.vars.pageName
    };
    if (user) {
      this.fundraiserService.campaignVisitTrack(this.fundraiser.id, user.id, payload).subscribe();
    }
  }
  /**Called once, before the instance is destroyed.
  * Add 'implements OnDestroy' to the class.
  */
  ngOnDestroy(): void {
    if (this.currencySubs) {
      this.currencySubs.unsubscribe();
    }
    this.seoService.removeMetaTags(this.tags);
    if (typeof document !== 'undefined') {
      document.body.classList.remove('container-body');
      document.body.classList.remove('fundraiserPage');
    }
    if (this.currencySubs) { this.currencySubs.unsubscribe(); }
    this.seoService.removeAmpHtml();
    this.vars.theme.next({
      'primary_color': null,
      'text_color': null,
      'logo': null,
      'access_url': null,
      'website_url': null
    });

    this.subs.forEach(s => s.unsubscribe());
    this.vars.showStoryOnFundraiser = false;

    if(this.showEndCampaignPage){
      this.events.sendSystemEvent({
        eventName: 'user_exited_without_action',
        event_type: 'campaign',
        event_type_id: this.fundraiser.id,
        page_name: 'EndedCampaignPage',
      })
    } 
  }

  getThisUserDonations() {
    if (!this.fundraiser?.id || !this.userData?.id || this.isDonationDetailsCalled) { return; }
    this.isDonationDetailsCalled = true;
    const qParam = `?with=donoravtar;comments;activation&donor_entity_details_id=${this.userData?.id}&sortedBy=desc&orderBy=id`;
    this.fundraiserService.getDonorCardDetails(this.fundraiser.id, qParam).subscribe((res: any) => {
      if (res?.data?.length > 0) {
        this.vars.fundraiser.isDonated = true;
      }
    });
  }

  checkForMedDoc() {
    if (this.userData && !this.fundraiser?.viewmedicalbill?.length && this.fundraiser?.count_medical_bill) {
      const url = environment.APP.API_URLS.GET_MEDICAL_BILL(this.vars.fundraiser.id);
      this.api.get(url).subscribe({
        next: (resp: any) => {
          this.fundraiser.viewmedicalbill = resp?.data || [];
          this.vars.fundraiser.viewmedicalbill = this.fundraiser.viewmedicalbill;
        },
        error: (err: any) => {}
      })

    }
  }

  handleGoToFundraiser() {
    this.util.router.navigate([], {
      queryParams: { show: 'default' },
      queryParamsHandling: 'merge',
    });
  }

  handleGoToFundraiserUpdates() {
    this.util.router.navigate([], {
      queryParams: { show: 'default' },
      queryParamsHandling: 'merge',
    });
    setTimeout(() => {
      this.tabs.setTab('Updates');
      this.cdr.detectChanges();
      window.scrollTo({ 
        top: document.body.scrollHeight * 0.5, 
        behavior: 'smooth' 
      });
    }, 1000);
  }
}
